var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-sidebar",
    {
      ref: "sidebar_fields",
      staticClass: "sidebar-fields",
      attrs: {
        id: _vm.sidebarFields,
        title: "Настройка колонок",
        right: "",
        shadow: "",
        backdrop: ""
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "b-row",
                { staticClass: "mx-1 my-2" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { size: "sm", variant: "danger" },
                      on: { click: _vm.resetColumns }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "trash-restore" }
                      }),
                      _vm._v("\n        Сброс\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.checkAll
                    ? _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.checkAllColumns(false)
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: ["far", "square"] }
                          }),
                          _vm._v("\n        Снять все\n      ")
                        ],
                        1
                      )
                    : _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "info" },
                          on: {
                            click: function($event) {
                              return _vm.checkAllColumns(true)
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "check-square" }
                          }),
                          _vm._v("\n        Выбрать все\n      ")
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-1",
                      attrs: { size: "sm", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.saveColumns(false)
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "save" }
                      }),
                      _vm._v("\n        Сохранить\n      ")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "px-1 py-1" },
        [
          _c(
            "b-list-group",
            { attrs: { flush: "", "bg-variant": "light" } },
            [
              _c(
                "draggable",
                {
                  attrs: { handle: ".drag-handle" },
                  model: {
                    value: _vm.localFields,
                    callback: function($$v) {
                      _vm.localFields = $$v
                    },
                    expression: "localFields"
                  }
                },
                _vm._l(_vm.localFields, function(field) {
                  return _c(
                    "div",
                    { key: field.id },
                    [
                      field.isSeparator
                        ? _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "font-weight-bold text-small text-muted text-uppercase px-2 py-2 mt-1 mb-1",
                              attrs: { variant: "secondary" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(field.label) +
                                  "\n          "
                              )
                            ]
                          )
                        : _c(
                            "b-list-group-item",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center text-small px-2 py-2",
                              attrs: { "bg-variant": "light" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-flex align-items-center"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "drag-handle text-primary mr-3"
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: "bars" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(field.label) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-checkbox", {
                                staticClass: "ml-1",
                                attrs: {
                                  disabled:
                                    _vm.visibleFields.length === 1 &&
                                    field.visible,
                                  stack: "",
                                  switch: ""
                                },
                                model: {
                                  value: field.visible,
                                  callback: function($$v) {
                                    _vm.$set(field, "visible", $$v)
                                  },
                                  expression: "field.visible"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "sr-only" })
                            ],
                            1
                          )
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ca1fe42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca1fe42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/DynamicTables.vue
// module id = null
// module chunks = 